export default __webpack_public_path__ + "static/media/cnaps-school-bg-white-logo.b507ffbb.svg";